'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window'];
angular.module('kerp-forms.forms').factory('CO_FCA_SCHEMA', schema);
